module.exports = __webpack_public_path__ + "static/media/NoTaxIcon.24e2a163.svg";